export enum ResolutionText {
  Success = 'Data has successfully been submitted.',
  Error = 'Error occurred while submitting data.',
};

export const RESOLUTION_TEXTS = Object.values(ResolutionText);

export const RESOLUTION_TEXT_VISABILITY_TIMEOUT = 5000;
